import { ComponentProps } from 'react';
import ModalBox from 'src/UI/common/ModalBox';
import { Client } from 'src/admin/users/types';
import { ContactsList } from './ContactsList';

type Props = {
  selectedClients: Client[];
  onSelectClient: (client: Client) => void;
  isCheckboxDisabled?: (client: Client) => boolean;
} & Partial<ComponentProps<typeof ModalBox>>;

export function AddFromContactsView({
  selectedClients,
  onSelectClient,
  isCheckboxDisabled = () => false,
  ...props
}: Props) {
  return (
    <ModalBox title="All contacts" {...props}>
      <ContactsList
        selectedClients={selectedClients}
        onSelectClient={onSelectClient}
        isCheckboxDisabled={isCheckboxDisabled}
      />
    </ModalBox>
  );
}
